<template>
    <v-card v-bind:class="{unread: notification.unread}">
    <v-card-title class="container-title">
      {{ notification.verb }}
    </v-card-title>
    <v-card-text  v-html="notification.description">
    </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["notification"],
  data() {
    return {
      deleteConfirmation: false,
      invitationLoading: false,
      dialog: null,
    };
  },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
  }),
  methods: {
    // isInvited() {
    //   return this.event.invitations.filter((e) => (e.invitee.id == this.ownProfile.id && e.status == "PE")).length > 0;
    // },
    // canJoin() {
    //   // User can join if no invitation with status HO or AC is found.
    //   return this.event.invitations.filter((e) => (e.invitee.id == this.ownProfile.id && (e.status == "AC" || e.status == "HO"))).length == 0;
    // },
    // async getIn(id) {
    //   this.invitationLoading = true;
    //   if (!this.isInvited()) {
    //   await this.$store.dispatch("createInvitationFromEvent", {
    //     invitee: this.ownProfile.id,
    //     inv_event: id,
    //     status: "AC",
    //   });
    //   }
    //   else {
    //     let invitation = this.event.invitations.find(e => e.invitee.id == this.ownProfile.id)
    //     await this.$store.dispatch("updateInvitations", {
    //       id: invitation.id,
    //     invitee: this.ownProfile.id,
    //     inv_event: id,
    //     status: "AC",
    //   });
    //   }

    //   this.invitationLoading = false;
    //   this.$store.dispatch("getEvents");
    // },
    // abbreviate(text) {
    //   return text.length > 150 ? `${text.slice(0, 147)}...` : text;
    // },
    // eventDetails() {
    //   this.$router.push(`/event/details/${this.event.event_slug}`);
    // },
    // editEvent(event) {
    //   this.$store.commit("SET_CURRENT_EVENT", event);
    //   this.$router.push(`/edit_event/${event.event_slug}`);
    // },
    // async deleteEvent(event) {
    //   await this.$store.dispatch("deleteEvent", event).then(() => {
    //     this.$store.dispatch("getMyEvents", event);
    //     this.$store.dispatch("getEvents", event);
    //   });
    // }
  },
};
</script>

<style scoped>
.unread {
background: darkgrey;
}
</style>